<template>
    <Swiper 
            v-if="posts.length"
            ref="swiperRef"
            class="swiper swiper--sustainability"
            :slides-per-view="3"
            :space-between="8"
            :modules="[Navigation]"
            :breakpoints="{
                0: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: 2
                },
                1200: {
                    slidesPerView: 3
                }
            }"
            :navigation="{
                nextEl: '.swiper-sustain .swiper-button-next',
                prevEl: '.swiper-sustain .swiper-button-prev'
            }"                    
        >
        <SwiperSlide v-for="(slide, index) in posts" :key="index">
            <div class="swiper__block">
                <div class="swiper__image">
                    <img class="swiper__img" :src="slide.image" :alt="slide.title" />
                </div>
                <div class="swiper__body">
                    <div class="swiper__title">{{ slide.title }}</div>
                    <div class="swiper__btn">
                        <div class="btn btn--primary" data-bs-toggle="modal" :data-bs-target="'#activities' + index">
                            <span class="btn__title">{{ translate('read.more') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </SwiperSlide>
       
    </Swiper>
    <div v-for="(slide, index) in posts" :key="index" class="modal modal--business fade" :id="`activities` + index" tabindex="-1" aria-labelledby="activitiesModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="modal-body">
                            <div class="modal-title modal-title--center">{{ slide.title }}</div>
                            <div class="modal-detail" v-html="slide.body"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="swiper-sustain">
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
    </div>


</template>

<script setup>

import { ref, onMounted } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Pagination, EffectFade, Navigation } from 'swiper/modules'
import { useTranslationStore } from '@/stores/translations'

import 'swiper/css/effect-fade'

const props = defineProps({
  posts: {
    type: Array,
    default: () => []
  }
})


const translationStore = useTranslationStore()
const translate = translationStore.translate

</script>

<style lang="scss" scoped>
 @import "@/assets/scss/app";


@each $lang in $languages {
    html[lang="#{$lang}"] {
        .swiper__title {
             @include font-size('body', en);
             line-height: 1;
        }
    }
}
 .swiper {
        &.swiper--sustainability {
            .swiper-slide {
                text-align: left;
            }
            .swiper__block {
                background-color: $white;
                padding: 1rem;
                border-radius: 12px;
            }
            .swiper__image {
                position: relative;
                aspect-ratio: 16/18;
            }
            .swiper__img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .swiper__body {
                text-align: center;
                padding: 0.5rem 0 0 0;
            }
            .swiper__title {
                color: $darkgreen-2;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
                min-height: 60px;
            }
            .swiper__btn {
                margin-top: 0.25rem;
                .btn {
                    background-color: $darkgreen-1;
                    .btn__title {
                        color: $white;
                    }
                     @include hover-focus-active {
                        background-color: $white;
                        .btn__title {
                            color: $darkgreen-1;
                        }
                     }
                }
            }
            
        }
}
.swiper-sustain {
    .swiper-button-next,
    .swiper-button-prev {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                color: $darkgreen-1;
                background-color: $lightgreen-1;
                @include transition;
                &::after {
                    @include transition;
                    font-size: px-to-rem(16);
                }
                &.swiper-button-disabled {
                    opacity: 0;
                }
                @include media-breakpoint-down(xs) {
                    width: 30px;
                    height: 30px;
                }
            }
            .swiper-button-prev {
                left: 0;
                &::after {
                    @include font-fontawesome('\f177');
                }
            }
            .swiper-button-next {
                right: 0;
                &::after {
                    @include font-fontawesome('\f178');
                }
            }
}

</style>